"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameState = void 0;
const stage_1 = require("./stage");
class GameState {
    constructor(p1, p2, stage) {
        this.turn = 0;
        this.round = 0;
        this.player1 = p1;
        this.player2 = p2;
        this.stage = stage !== null && stage !== void 0 ? stage : stage_1.GameStage.Pregame;
    }
}
exports.GameState = GameState;
